import { RefreshCw } from "lucide-react";
import { useIsFetching, useQueryClient } from "@tanstack/react-query";
import { Button } from "../../ui/button";

/**
 * Re-fetches everything the current page is showing: every active query refetches, so the cards, charts and tables update
 * together and keep their current values on screen until the new ones arrive. The icon spins while any request is in flight.
 */
export function RefreshButton() {
  const queryClient = useQueryClient();
  const fetching = useIsFetching() > 0;

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-8 gap-2 px-3 text-xs"
      disabled={fetching}
      onClick={() => queryClient.refetchQueries({ type: "active" })}
      title="Reload the data on this page"
      aria-label="Refresh data"
    >
      <RefreshCw className={fetching ? "animate-spin" : undefined} />
      Refresh
    </Button>
  );
}
